/**
 * 헤더 아이콘(레벨·별포인트·출석) 표시 너비(px)
 * - 아이콘 파일은 고해상도(6배)라 너비를 지정하지 않으면 파일 크기대로 크게 표시된다.
 * - 값은 교체 전 1배 이미지의 픽셀 너비와 같다. 높이는 비율대로 자동 계산된다.
 */
export const HEADER_ICON_WIDTH = {
  level: 24,
  star: 30,
  calendar: 25,
} as const;

/**
 * 모험 인물 카드의 업적 아이콘(깃발·트로피) 표시 너비(px)
 * - 고해상도(6배) 파일로 교체해서, 교체 전 1배 이미지 너비를 지정해야 크기·위치가 그대로 유지된다.
 * - 자물쇠(locked)는 교체하지 않아 지정하지 않는다.
 */
export const ACHIEVEMENT_ICON_WIDTH: Record<string, number | undefined> = {
  flag: 39,
  trophy: 50,
};

/**
 * 프로필 이미지(바깥 원 테두리 포함) 크기
 * - Figma 기준은 레이아웃 폭 723px 중 189.08px(화면 폭의 26.15%)이지만,
 *   실제 화면에서 작아 보여 약 10% 키운 29%로 쓴다 (2026-11-01 요청).
 * - PC 브라우저처럼 화면이 넓을 때 너무 커지지 않도록 210px를 상한으로 둔다.
 */
export const PROFILE_IMAGE_SIZE = 'min(29vw, 210px)';
